import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { GiftOutlineIcon } from '@beef/ui-kit';
import { NText } from '@fttb/common/components';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getTariffAction } from "../../../../store/blocks/tariffs/tariffSelectors";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var _TariffGift = function _TariffGift(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(NText, {
    className: cn('component', className),
    color: "inherit",
    isNoUnderline: true,
    size: "size5-m",
    "data-t-id": "components-TariffGift"
  }, /*#__PURE__*/React.createElement(GiftOutlineIcon, {
    className: cn('icon'),
    "data-t-id": "components-TariffGift"
  }), children);
};
_TariffGift.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getTariffAction(state),
    shouldRender: !!getTariffAction(state)
  };
};
export var TariffGift = compose(connect(mapStateToProps), withRenderFlag)(_TariffGift);